




































































































import { snakeCase, cloneDeep } from 'lodash'
import { Component, Emit, Prop } from 'vue-property-decorator'

import WindowResizeMixin from '../../../../../../../../../../../logic/helpers/WindowResizeMixin'
import { SocketsActionsTypes } from '../../../../../../../../components'
import CustomEditor from '../../../../../../../Editor/CustomEditor'
import ActionNodeAction, { ActionNodeActionProxy } from '../../../../../Action/logic/Actions'
import { KickAction } from '../../../../../Action/logic/Actions/KickAction/KickAction'
import { KickActionProxy } from '../../../../../Action/logic/Actions/KickAction/KickActionProxy'
import {
  AddLabelAction,
  LabelsAction,
  RemoveLabelAction
} from '../../../../../Action/logic/Actions/LabelsAction/LabelsAction'
import { LabelsActionProxy } from '../../../../../Action/logic/Actions/LabelsAction/LabelsActionProxy'
import { NotifyGroupAction } from '../../../../../Action/logic/Actions/NotifyGroupAction/NotifyGroupAction'
import { NotifyGroupActionProxy } from '../../../../../Action/logic/Actions/NotifyGroupAction/NotifyGroupActionProxy'
import { NotifyUsersAction } from '../../../../../Action/logic/Actions/NotifyUsersAction/NotifyUsersAction'
import { NotifyUsersActionProxy } from '../../../../../Action/logic/Actions/NotifyUsersAction/NotifyUsersActionProxy'
import { PropertyAction } from '../../../../../Action/logic/Actions/PropertyAction/PropertyAction'
import { PropertyActionProxy } from '../../../../../Action/logic/Actions/PropertyAction/PropertyActionProxy'
import { RemoveProperties } from '../../../../../Action/logic/Actions/RemoveProperties/RemoveProperties'
import { RemovePropertiesProxy } from '../../../../../Action/logic/Actions/RemoveProperties/RemovePropertiesProxy'
import { ActionTypes } from '../../../../../Action/logic/Actions/types'
import ActionNodeActions from '../../../../../Action/ui/sidebar/Actions/ActionNodeActions.vue'
import AddingAction from '../../../../../Action/ui/sidebar/Actions/AddingAction.vue'
import { SendMessageNode } from "../../../../logic/SendMessageNode";
import { SendMessageNodeProps } from '../../../../logic/types'

@Component({
  data() {
    return {
      snakeCase,
    }
  },
  components: {
    AddingAction,
    ActionNodeActions,
  }
})
export default class UserInputActionsList extends WindowResizeMixin {
  @Prop() actions!: Array<ActionNodeAction>

  @Prop() node!: SendMessageNode

  @Prop() nodeProps!: SendMessageNodeProps

  @Prop() nodeSocketsActions!: SocketsActionsTypes

  @Prop() editor!: CustomEditor

  proxyActions: Array<ActionNodeActionProxy> = []

  addingAction = false

  addAction(type: ActionTypes): void {
    switch (type) {
      case ActionTypes.RemoveLabel:
        this.proxyActions.push(new LabelsActionProxy(new RemoveLabelAction().getNewModel()))
        break
      case ActionTypes.AddLabel:
        this.proxyActions.push(new LabelsActionProxy(new AddLabelAction().getNewModel()))
        break
      case ActionTypes.NotifyUsers:
        this.proxyActions.push(new NotifyUsersActionProxy(new NotifyUsersAction().getNewModel(), this.nodeSocketsActions))
        break
      case ActionTypes.NotifyGroup:
        this.proxyActions.push(new NotifyGroupActionProxy(new NotifyGroupAction().getNewModel(), this.nodeSocketsActions))
        break
      case ActionTypes.Property:
        this.proxyActions.push(new PropertyActionProxy(new PropertyAction().getNewModel(), this.nodeProps))
        break
      case ActionTypes.RemoveProperties:
        this.proxyActions.push(new RemovePropertiesProxy(new RemoveProperties().getNewModel()))
        break
      case ActionTypes.Kick:
        this.proxyActions.push(new KickActionProxy(new KickAction().getNewModel()))
        break

    }

    if (this.nodeProps?.externalActions && this.nodeProps?.externalActions.length) {
      this.nodeProps.externalActions.forEach(a => {
        if (type === a.type) {
          this.proxyActions.push(new a.proxy(new a.action().getNewModel(), this.nodeProps))
        }
      })
    }

    this.addingAction = false
  }

  removeAction(action: ActionNodeActionProxy): void {
    this.proxyActions.splice(this.proxyActions.indexOf(action), 1)
  }

  created(): void {
    this.setNodeActionsToEdit()
  }

  setNodeActionsToEdit(): void {
    this.actions.forEach((a) => {
      if (a instanceof LabelsAction) {
        this.proxyActions.push(new LabelsActionProxy(cloneDeep(a)))
      }

      if (a instanceof NotifyUsersAction) {
        this.proxyActions.push(new NotifyUsersActionProxy(cloneDeep(a), this.nodeSocketsActions))
      }

      if (a instanceof NotifyGroupAction) {
        this.proxyActions.push(new NotifyGroupActionProxy(cloneDeep(a), this.nodeSocketsActions))
      }

      if (a instanceof PropertyAction) {
        this.proxyActions.push(new PropertyActionProxy(cloneDeep(a), this.nodeProps))
      }

      if (a instanceof RemoveProperties) {
        this.proxyActions.push(new RemovePropertiesProxy(cloneDeep(a)))
      }

      if (a instanceof KickAction) {
        this.proxyActions.push(new KickActionProxy(cloneDeep(a)))
      }

      if (this.nodeProps?.externalActions && this.nodeProps?.externalActions.length) {
        this.nodeProps.externalActions.forEach(ea => {
          if (a instanceof ea.action) {
            this.proxyActions.push(new ea.proxy(cloneDeep(a), this.nodeProps))
          }
        })
      }
    })
  }

  refreshActions(): void {
    this.proxyActions = []

    this.setNodeActionsToEdit()
  }

  get areActionsValid() {
    return this.proxyActions.every(a => a.isActionValid())
  }

  @Emit()
  setActions(): Array<ActionNodeAction> {
    return this.proxyActions.map((a) => a.getModel())
  }
}
